export const MULTI_PACKAGE_DELIVERY_AVAILABILITY = {
  EG: false,
  SA: true
};
